module.exports = __webpack_public_path__ + "static/media/vm_ambienti1.3e7901b6.png";